import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { ActiveStay, PERIOD_VISITOR_CATEGORY } from 'src/features/stay/types';

const RESOURCE = `sp-core/:parkingId/visitors/active-stay/`;

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    parkingId: string;
    membership?: string[];
    visitor_category?: PERIOD_VISITOR_CATEGORY;
}

const queryFn = ({ parkingId, ...params }: DTO): Promise<ListResponseSmartParkAPI<ActiveStay>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_ACTIVE_STAYS_RESOURCE, useQueryHook as useListActiveStays };
